/** Kuwait — simplified accurate colors (public domain pattern). */
export function FlagKuwait({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 900 450" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path fill="#007A3D" d="M0 0h900v150H0z" />
      <path fill="#FFF" d="M0 150h900v150H0z" />
      <path fill="#CE1126" d="M0 300h900v150H0z" />
      <path fill="#000" d="M0 0 300 225 0 450z" />
    </svg>
  )
}
